import { unsafeCSS, html, nothing } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { e } from "../../scoped-registry-mixin-2fqf-E5n.js";
import { watch } from "../../utilities/watch.js";
import { LeafElement } from "../../components/leaf-element.js";
import { SlotController } from "../../utilities/slot.js";
const styles = ":host {\n  display: block;\n}\n:host .chc-c-product-card {\n  background-color: var(--leaf-color-bg-default);\n  border: var(--leaf-base-border-width-2) var(--leaf-base-border-style-solid) var(--leaf-color-border-default);\n  border-top-left-radius: var(--leaf-base-border-radius-30);\n  border-bottom-right-radius: var(--leaf-base-border-radius-30);\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  overflow: hidden;\n}\n:host .chc-c-product-card--active-outline {\n  border: var(--leaf-border-width-focus) solid var(--leaf-color-border-active-outline);\n}\n:host .chc-c-product-card__content {\n  flex: 1;\n}\n:host .chc-c-product-card__content {\n  flex: 2;\n}\n:host .chc-c-product-card__header,\n:host .chc-c-product-card__content,\n:host .chc-c-product-card__footer {\n  display: flex;\n  flex-direction: column;\n}\n:host .chc-c-product-card__footer {\n  display: flex;\n  flex-direction: column;\n  padding-top: var(--leaf-spacing-16);\n  padding-bottom: var(--leaf-spacing-32);\n}\n:host .chc-c-product-card__footer-compare ::slotted([slot=footer-compare]) {\n  display: flex;\n  justify-content: center;\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _CHCProductCard = class _CHCProductCard extends e(LeafElement) {
  constructor() {
    super(...arguments);
    this.slotController = new SlotController(this);
    this.selected = false;
  }
  selectHandler() {
    if (this.selected) {
      this.emit("chc-product-card:selected", { detail: this.value });
    }
  }
  handleCheckboxChange(event) {
    const { detail } = event;
    this.selected = detail.checked;
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("leaf-checkbox:change", this.handleCheckboxChange);
  }
  disconnectedCallback() {
    this.removeEventListener("leaf-checkbox:change", this.handleCheckboxChange);
    super.disconnectedCallback();
  }
  render() {
    const componentClassName = {
      "chc-c-product-card": true,
      "chc-c-product-card--active-outline": this.selected === true
    };
    return html`<div class=${classMap(componentClassName)}>
      <div class="chc-c-product-card__header">
        <slot name="main-header"></slot>
      </div>
      <div class="chc-c-product-card__content">
        <slot name="main-content"></slot>
      </div>
      ${this.slotController.hasNamedSlot("footer") ? html` <div class="chc-c-product-card__footer">
            <slot name="footer"></slot>
          </div>` : nothing}
      <div class="chc-c-product-card__footer-compare">
        <slot name="footer-compare"></slot>
      </div>
    </div>`;
  }
};
_CHCProductCard.styles = unsafeCSS(styles);
let CHCProductCard = _CHCProductCard;
__decorateClass([
  property({ reflect: true })
], CHCProductCard.prototype, "value", 2);
__decorateClass([
  property({ reflect: true, type: Boolean })
], CHCProductCard.prototype, "selected", 2);
__decorateClass([
  watch("selected")
], CHCProductCard.prototype, "selectHandler", 1);
export {
  CHCProductCard
};
//# sourceMappingURL=product-card.component.js.map
